module.exports = __webpack_public_path__ + "static/media/Logo_001.1957aa1c.png";